import { createSlice } from "@reduxjs/toolkit";
import { buscarLancamentoControleAporte } from "../../../services/lancamentoControleAporteService";
import { resetAll } from "../../actions/actions";
import BuscarLancamentoControleAporteModel from "../../../models/lancamentoControleAporte/chamadas/buscarLancamentoControleAporteModel";
import { LancamentoControleAporteModel } from "../../../models/lancamentoControleAporte/lancamentoControleAporteModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");
export interface LancamentoControleAporteState {
  //buscar lancamento controle aporte
  loading: boolean;
  busca: BuscarLancamentoControleAporteModel;
  list: LancamentoControleAporteModel[];
  entity: LancamentoControleAporteModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
  modalRecebimento: boolean;
}

const initialState: LancamentoControleAporteState = {
  //buscar lancamento controle aporte
  loading: false,
  busca: {
    idEmpresa: null,
    idTipoLancamentoControleAporte: null,
    dataInicioTransacao: dayjs().startOf("month").toDate(),
    dataFimTransacao: dayjs().endOf("month").toDate(),
    idSorteio: null,
  } as BuscarLancamentoControleAporteModel,
  list: [],
  entity: {} as LancamentoControleAporteModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
  modalRecebimento: false,
};

export const lancamentoControleAporteSlice = createSlice({
  name: "lancamentoControleAporte",
  initialState,
  reducers: {
    //buscar lancamento controle aporte
    setBuscaLancamentoControleAporte: (state, action) => {
      state.busca = action.payload;
    },
    setEntityLancamentoControleAporte: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarLancamentoControleAporte: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarLancamentoControleAporte: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalRecebimentoLancamentoControleAporte: (state, action) => {
      state.modalRecebimento = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar lancamento controle aporte
    builder.addCase(buscarLancamentoControleAporte.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarLancamentoControleAporte.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarLancamentoControleAporte.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar lancamento controle aporte
  setBuscaLancamentoControleAporte,
  setEntityLancamentoControleAporte,
  //internal
  setModalCadastrarLancamentoControleAporte,
  setModalDeletarLancamentoControleAporte,
  setModalRecebimentoLancamentoControleAporte,
} = lancamentoControleAporteSlice.actions;

export default lancamentoControleAporteSlice.reducer;
